"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _babelHelperVueJsxMergeProps = _interopRequireDefault(require("@vue/babel-helper-vue-jsx-merge-props"));
var _render = _interopRequireDefault(require("@/components/FormGenerator/components/render/render.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ruleTrigger = {
  'el-input': 'blur',
  'el-input-number': 'blur',
  'el-select': 'change',
  'el-radio-group': 'change',
  'el-checkbox-group': 'change',
  'el-cascader': 'change',
  'el-time-picker': 'change',
  'el-date-picker': 'change',
  'el-rate': 'change'
};
function renderFrom(h) {
  var formConfCopy = this.formConfCopy;
  return h("el-row", {
    "attrs": {
      "gutter": formConfCopy.gutter
    }
  }, [h("el-form", (0, _babelHelperVueJsxMergeProps.default)([{
    "attrs": {
      "size": formConfCopy.size,
      "label-position": formConfCopy.labelPosition,
      "disabled": formConfCopy.disabled,
      "label-width": "".concat(formConfCopy.labelWidth, "px")
    },
    "ref": formConfCopy.formRef
  }, {
    "props": {
      model: this[formConfCopy.formModel]
    }
  }, {
    "attrs": {
      "rules": this[formConfCopy.formRules]
    }
  }]), [renderFormItem.call(this, h, formConfCopy.fields), formConfCopy.formBtns && formBtns.call(this, h)])]);
}
function formBtns(h) {
  return h("el-col", [h("el-form-item", {
    "attrs": {
      "size": 'mini'
    }
  }, [h("el-button", {
    "attrs": {
      "type": 'primary'
    },
    "on": {
      "click": this.submitForm
    }
  }, ["\u63D0\u4EA4"])])]);
}
function renderFormItem(h, elementList) {
  var _this = this;
  return elementList.map(function (scheme) {
    var config = scheme.__config__;
    var layout = layouts[config.layout];
    if (layout) {
      return layout.call(_this, h, scheme);
    }
    throw new Error("\u6CA1\u6709\u4E0E".concat(config.layout, "\u5339\u914D\u7684layout"));
  });
}
function renderChildren(h, scheme) {
  var config = scheme.__config__;
  if (!Array.isArray(config.children)) return null;
  return renderFormItem.call(this, h, config.children);
}
function setValue(event, config, scheme) {
  this.$set(config, 'defaultValue', event);
  this.$set(this[this.formConf.formModel], scheme.__vModel__, event);
}
function findFieldTenantBlock(tenantFieldIssues, fieldName) {
  if (!tenantFieldIssues || !fieldName || !tenantFieldIssues.length) {
    return null;
  }
  for (var i = 0; i < tenantFieldIssues.length; i++) {
    var it = tenantFieldIssues[i];
    if (it && it.fieldName === fieldName) {
      return it;
    }
  }
  return null;
}

/** 表单项标签：标题（异常为红）+ 问号表格 + 可选「初始化」（各租户均无该字段时）+ 下方 __vModel__ */
function renderFormItemLabel(h, scheme, config, showKey, tenantFieldIssues, options) {
  if (!showKey) {
    return null;
  }
  options = options || {};
  var issueHighlight = options.issueHighlight !== false;
  var vModel = scheme.__vModel__;
  var hasTitle = config.showLabel && config.label;
  if (!vModel && !hasTitle) {
    return null;
  }
  var block = findFieldTenantBlock(tenantFieldIssues, vModel);
  var issueRows = block && block.issues ? block.issues : [];
  var hasTenantIssue = issueRows.length > 0;
  var popoverVnode = null;
  if (vModel && hasTenantIssue) {
    popoverVnode = h("el-popover", {
      "attrs": {
        "placement": "bottom-start",
        "width": "520",
        "trigger": "click"
      }
    }, [h("el-table", {
      "attrs": {
        "data": issueRows,
        "size": "mini",
        "max-height": "360"
      },
      "style": "width:100%"
    }, [h("el-table-column", {
      "attrs": {
        "prop": "tenantName",
        "label": "租户",
        "width": "200"
      }
    }), h("el-table-column", {
      "attrs": {
        "prop": "issue",
        "label": "问题说明",
        "min-width": "260"
      }
    })]), h("i", {
      "slot": "reference",
      "class": "el-icon-question parser-tenant-field-q"
    })]);
  }
  var showErrorStyle = issueHighlight && hasTenantIssue;
  var titleClass = 'parser-item-label-text' + (showErrorStyle ? ' parser-tenant-field-error' : '');
  var keyClass = 'parser-item-key' + (!hasTitle && showErrorStyle ? ' parser-tenant-field-error' : '');
  var showFieldInit = options.allowFieldInit === true && vModel && block && (block.tenantCanSyncFieldFromDefault === true || block.tenant_can_sync_field_from_default === true);
  var sf = options.syncingField;
  var syncing = !!(sf !== undefined && sf !== null && sf !== '' && vModel !== undefined && vModel !== null && vModel !== '' && String(sf) === String(vModel));
  var fieldInitBtnVnode = null;
  if (showFieldInit && typeof options.onFieldInit === 'function') {
    fieldInitBtnVnode = h("el-button", {
      "attrs": {
        "type": "text",
        "size": "mini",
        "loading": !!syncing,
        "disabled": !!syncing
      },
      "on": {
        "click": function click(e) {
          e.preventDefault();
          e.stopPropagation();
          if (syncing) return;
          options.onFieldInit(vModel);
        }
      }
    }, ["\u521D\u59CB\u5316"]);
  }
  if (hasTitle) {
    return h("span", {
      "class": "parser-item-label-stack"
    }, [h("span", {
      "class": "parser-item-label-row"
    }, [h("span", {
      "class": titleClass
    }, [config.label]), popoverVnode, fieldInitBtnVnode]), vModel ? h("span", {
      "class": "parser-item-key"
    }, [vModel]) : null]);
  }
  return h("span", {
    "class": "parser-item-label-stack"
  }, [h("span", {
    "class": "parser-item-label-row"
  }, [vModel ? h("span", {
    "class": keyClass
  }, [vModel]) : null, popoverVnode, fieldInitBtnVnode])]);
}
function buildListeners(scheme) {
  var _this2 = this;
  var config = scheme.__config__;
  var methods = this.formConf.__methods__ || {};
  var listeners = {};

  // 给__methods__中的方法绑定this和event
  Object.keys(methods).forEach(function (key) {
    listeners[key] = function (event) {
      return methods[key].call(_this2, event);
    };
  });
  // 响应 render.js 中的 vModel $emit('input', val)
  listeners.input = function (event) {
    return setValue.call(_this2, event, config, scheme);
  };
  return listeners;
}
var layouts = {
  colFormItem: function colFormItem(h, scheme) {
    var _this3 = this;
    var config = scheme.__config__;
    var listeners = buildListeners.call(this, scheme);
    var labelWidth = config.labelWidth ? "".concat(config.labelWidth, "px") : null;
    if (config.showLabel === false) labelWidth = '0';
    var showKey = this.showItemConfigKey;
    var tenantFieldIssues = this.tenantFieldIssues || [];
    var labelOptions = {
      issueHighlight: this.tenantFieldIssueHighlight !== false,
      allowFieldInit: this.allowFieldTenantInitButton === true,
      syncingField: this.syncingTenantFieldName || '',
      onFieldInit: function onFieldInit(field) {
        return _this3.$emit('field-tenant-init', {
          fieldName: field
        });
      }
    };
    var labelSlot = showKey ? renderFormItemLabel(h, scheme, config, true, tenantFieldIssues, labelOptions) : null;
    var labelPropPlain = config.showLabel ? config.label : '';
    var labelSlotVnode = labelSlot ? h("span", {
      "slot": "label"
    }, [labelSlot]) : null;
    var formItemProps = {
      labelWidth: labelWidth,
      prop: scheme.__vModel__
    };
    if (!labelSlotVnode) {
      formItemProps.label = labelPropPlain;
    }
    if (config.tips && !config.tipsIsLink) {
      return h("el-col", {
        "attrs": {
          "span": config.span
        }
      }, [h("el-form-item", {
        "props": _objectSpread({}, formItemProps)
      }, [labelSlotVnode, h("el-tooltip", {
        "attrs": {
          "effect": "dark",
          "placement": "top-start"
        },
        "style": "padding:10px 5px 0 0;"
      }, ["\xA0 \xA0 \xA0 \xA0 \xA0 \xA0 ", h("i", {
        "class": "el-icon-warning-outline"
      }), "\xA0 \xA0 \xA0 \xA0 \xA0 \xA0 ", h("div", {
        "slot": "content",
        "style": "max-width:400px;"
      }, [config.tipsDesc]), "\xA0 \xA0 \xA0 \xA0 \xA0"]), h(_render.default, {
        "attrs": {
          "conf": scheme
        },
        "on": _objectSpread({}, listeners)
      })])]);
    } else if (config.tips && config.tipsIsLink) {
      return h("el-col", {
        "attrs": {
          "span": config.span
        }
      }, [h("el-form-item", {
        "props": _objectSpread({}, formItemProps)
      }, [labelSlotVnode, h("el-tooltip", {
        "attrs": {
          "effect": "dark",
          "placement": "top-start"
        },
        "style": "padding:10px 5px 0 0;"
      }, ["\xA0 \xA0 \xA0 \xA0 \xA0 \xA0 ", h("i", {
        "class": "el-icon-warning-outline"
      }), "\xA0 \xA0 \xA0 \xA0 \xA0 \xA0 ", h("div", {
        "slot": "content",
        "style": "max-width:400px;"
      }, [h("a", {
        "attrs": {
          "href": config.tipsLink,
          "target": "_blank"
        }
      }, [config.tipsDesc])]), "\xA0 \xA0 \xA0 \xA0 \xA0"]), h(_render.default, {
        "attrs": {
          "conf": scheme
        },
        "on": _objectSpread({}, listeners)
      })])]);
    } else {
      return h("el-col", {
        "attrs": {
          "span": config.span
        }
      }, [h("el-form-item", {
        "props": _objectSpread({}, formItemProps)
      }, [labelSlotVnode, h(_render.default, {
        "attrs": {
          "conf": scheme
        },
        "on": _objectSpread({}, listeners)
      })])]);
    }
  },
  rowFormItem: function rowFormItem(h, scheme) {
    var child = renderChildren.apply(this, arguments);
    if (scheme.type === 'flex') {
      child = h("el-row", {
        "attrs": {
          "type": scheme.type,
          "justify": scheme.justify,
          "align": scheme.align
        }
      }, [child]);
    }
    return h("el-col", {
      "attrs": {
        "span": scheme.span
      }
    }, [h("el-row", {
      "attrs": {
        "gutter": scheme.gutter
      }
    }, [child])]);
  }
};
var _default2 = exports.default = {
  components: {
    render: _render.default
  },
  props: {
    canNotSubmit: {
      type: Boolean,
      default: false
    },
    formConf: {
      type: Object,
      required: true
    },
    formEditData: {
      type: Object
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    /** 为 true 时在每个表单项标题下展示配置 key（__vModel__），默认关闭以免影响其它页面 */
    showItemConfigKey: {
      type: Boolean,
      default: false
    },
    /** 巡检接口 tenantFieldDetails：按字段的租户异常明细，用于标题颜色与问号弹层 */
    tenantFieldIssues: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /** 为 false 时不在标签上使用红色（仍显示问号与「初始化」按钮），用于「全租户未落库」等场景 */
    tenantFieldIssueHighlight: {
      type: Boolean,
      default: true
    },
    /** 为 true 且巡检标记 tenantCanSyncFieldFromDefault 时展示「初始化」（各租户均无该字段） */
    allowFieldTenantInitButton: {
      type: Boolean,
      default: false
    },
    /** 正在同步的字段 __vModel__，用于按钮 loading */
    syncingTenantFieldName: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    var _this4 = this;
    if (this.isEdit) {
      // 初始化待编辑数据
      this.formConf.fields.forEach(function (conf) {
        // 设置现有的数据
        var hasValueForEdit = _this4.formEditData[conf.__vModel__];
        if (hasValueForEdit) {
          conf.__config__.defaultValue = hasValueForEdit;
        }
        // 如果是el-select标签 判断数据后改变实现默认选中效果
        if (conf.__config__.tag === 'el-select' || conf.__config__.tag === 'el-radio-group') {
          var perValue = conf.__slot__.options.filter(function (option) {
            return option.value == _this4.formEditData[conf.__vModel__];
          });
          if (perValue.length > 0) {
            // 有表单数据
            conf.__config__.defaultValue = perValue[0].value;
          }
        }
      });
    }
    var data = _defineProperty(_defineProperty({
      formConfCopy: JSON.parse(JSON.stringify(this.formConf))
    }, this.formConf.formModel, {}), this.formConf.formRules, {});
    this.initFormData(data.formConfCopy.fields, data[this.formConf.formModel]);
    this.buildRules(data.formConfCopy.fields, data[this.formConf.formRules]);
    return data;
  },
  methods: {
    initFormData: function initFormData(componentList, formData) {
      var _this5 = this;
      componentList.forEach(function (cur) {
        var config = cur.__config__;
        if (cur.__vModel__) formData[cur.__vModel__] = config.defaultValue;
        if (config.children) _this5.initFormData(config.children, formData);
      });
    },
    buildRules: function buildRules(componentList, rules) {
      var _this6 = this;
      componentList.forEach(function (cur) {
        var config = cur.__config__;
        if (Array.isArray(config.regList)) {
          if (config.required) {
            var required = {
              required: config.required,
              message: cur.placeholder
            };
            if (Array.isArray(config.defaultValue)) {
              required.type = 'array';
              required.message = "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A".concat(config.label);
            }
            required.message === undefined && (required.message = "".concat(config.label, "\u4E0D\u80FD\u4E3A\u7A7A"));
            config.regList.push(required);
          }
          rules[cur.__vModel__] = config.regList.map(function (item) {
            item.pattern && (item.pattern = eval(item.pattern));
            item.trigger = ruleTrigger && ruleTrigger[config.tag];
            return item;
          });
        }
        if (config.children) _this6.buildRules(config.children, rules);
      });
    },
    resetForm: function resetForm() {
      this.$emit('resetForm', this.formConf);
      this.formConfCopy = JSON.parse(JSON.stringify(this.formConf));
      this.$refs[this.formConf.formRef].resetFields();
    },
    submitForm: function submitForm() {
      var _this7 = this;
      this.$refs[this.formConf.formRef].validate(function (valid) {
        if (!valid) return false;
        // 触发sumit事件
        if (_this7.canNotSubmit) {
          alert('禁止提交');
          return;
        }
        _this7.$emit('submit', _this7[_this7.formConf.formModel]);
        return true;
      });
    }
  },
  render: function render(h) {
    return renderFrom.call(this, h);
  }
};